import { ClientFeatureControlsEntity } from '@/entities/client-feature-controls.entity';

export const LIVE_CLIENT_FEATURE_CONTROL_KEYS = [
    'allowResponseSending',
    'allowAiAnswerGeneration',
    'allowAiAnalysis',
    'autoReviewAiAnalysisEnabled',
    'autoReviewProcessingEnabled',
] as const satisfies ReadonlyArray<keyof ClientFeatureControlsEntity>;

export type LiveClientFeatureControlKey = (typeof LIVE_CLIENT_FEATURE_CONTROL_KEYS)[number];

type ClientFeatureControlDescriptor = {
    code: string;
    message: string;
    capability: 'review-answer' | 'ai-analysis' | 'auto-replies';
};

const CLIENT_FEATURE_CONTROL_DESCRIPTORS = {
    allowResponseSending: {
        code: 'client_feature_control.policy.response_sending_disabled',
        message: 'Отправка ответов отключена в настройках клиента',
        capability: 'review-answer',
    },
    allowAiAnswerGeneration: {
        code: 'client_feature_control.policy.ai_answer_generation_disabled',
        message: 'Формирование ИИ-ответов отключено в настройках клиента',
        capability: 'ai-analysis',
    },
    allowAiAnalysis: {
        code: 'client_feature_control.policy.ai_analysis_disabled',
        message: 'ИИ-анализ отключен в настройках клиента',
        capability: 'ai-analysis',
    },
    autoReviewAiAnalysisEnabled: {
        code: 'client_feature_control.policy.auto_review_ai_analysis_disabled',
        message: 'Автоматический ИИ-анализ входящих отзывов отключен в настройках клиента',
        capability: 'ai-analysis',
    },
    autoReviewProcessingEnabled: {
        code: 'client_feature_control.policy.auto_review_processing_disabled',
        message: 'Автообработка отзывов отключена в настройках клиента',
        capability: 'auto-replies',
    },
} as const satisfies Record<LiveClientFeatureControlKey, ClientFeatureControlDescriptor>;

export const resolveClientFeatureControlDescriptor = (
    controlKey: LiveClientFeatureControlKey,
): ClientFeatureControlDescriptor => {
    return CLIENT_FEATURE_CONTROL_DESCRIPTORS[controlKey];
};

export const isClientFeatureControlEnabled = (
    featureControls: ClientFeatureControlsEntity,
    controlKey: LiveClientFeatureControlKey,
): boolean => {
    return featureControls[controlKey];
};
